/* istanbul ignore file */
/* Ignoring file from coverage as its exported functions are all wiring */
import { _getLogger } from '@doxyme/analytics';

const DATADOG_LOGGER_NAME = 'DataDog';

/**
 * Sends a log to DataDog
 * @param {string} message Message string to be sent to DataDog
 * @param {Record<string, unknown>} data Data to be sent to DataDog
 * @returns {void}
 */
export const sendLogToDataDog = (
  message: string,
  data: Record<string, unknown>,
): void => _getLogger(DATADOG_LOGGER_NAME).log(message, data);

/**
 * Sends an error log to DataDog
 * @param {string} message Message string to be sent to DataDog
 * @param {Record<string, unknown>} data Data to be sent to DataDog
 * @returns {void}
 */
export const sendErrorLogToDataDog = (
  message: string,
  data: Record<string, unknown>,
): void => _getLogger(DATADOG_LOGGER_NAME).error(message, data);
